/**
 * Case categories for the chat intake flow
 * Used by ChatPage for client type selection
 */

// Categories for private persons
export const privateCaseCategories = [
  { 
    id: 'arbeidsrett', 
    icon: '⚖️', 
    label: 'Arbeidsrett', 
    desc: 'Oppsigelse, diskriminering, ansettelse',
    subCategories: [
      { id: 'oppsigelse', icon: '📄', label: 'Oppsigelse', desc: 'Urettmessig eller usaklig oppsigelse' },
      { id: 'diskriminering', icon: '⚠️', label: 'Diskriminering', desc: 'Diskriminering på arbeidsplassen' },
      { id: 'lonn', icon: '💰', label: 'Lønn & Feriepenger', desc: 'Lønnskrav eller utbetaling' },
      { id: 'arbeidskonflikt', icon: '⚔️', label: 'Arbeidskonflikt', desc: 'Konflikt med arbeidsgiver eller kollega' },
      { id: 'annet_arbeidsrett', icon: '⚡', label: 'Annet', desc: 'Annen arbeidsrettslig sak' }
    ]
  },
  { 
    id: 'kontrakt', 
    icon: '📝', 
    label: 'Kontraktsrett', 
    desc: 'Avtaler, tvister, mislighold',
    subCategories: [
      { id: 'mislighold', icon: '❌', label: 'Mislighold', desc: 'Motpart bryter avtalen' },
      { id: 'tolkningstvister', icon: '📖', label: 'Tolkningstvister', desc: 'Uenighet om avtalens innhold' },
      { id: 'heving', icon: '🔙', label: 'Heving av avtale', desc: 'Ønske om å heve kontrakten' },
      { id: 'erstatning_kontrakt', icon: '💸', label: 'Erstatningskrav', desc: 'Krav om erstatning fra motpart' },
      { id: 'annet_kontrakt', icon: '⚡', label: 'Annet', desc: 'Annen kontraktsrettslig sak' }
    ]
  },
  { 
    id: 'eiendom', 
    icon: '🏠', 
    label: 'Eiendom', 
    desc: 'Kjøp/salg, nabokonflikt, leie',
    subCategories: [
      { id: 'kjop_salg', icon: '🏡', label: 'Kjøp/Salg bolig', desc: 'Tvister ved eiendomshandel' },
      { id: 'nabokonflikt', icon: '🤝', label: 'Nabokonflikt', desc: 'Konflikt med nabo' },
      { id: 'leieforhold', icon: '🔑', label: 'Leieforhold', desc: 'Utleier/leietaker problemer' },
      { id: 'byggesak', icon: '🏗️', label: 'Byggesak', desc: 'Byggetillatelse eller håndverkertvist' },
      { id: 'annet_eiendom', icon: '⚡', label: 'Annet', desc: 'Annen eiendomsrettslig sak' }
    ]
  },
  { 
    id: 'familie', 
    icon: '👨‍👩‍👧', 
    label: 'Familie & Arv', 
    desc: 'Skilsmisse, samlivsbrudd, arv',
    subCategories: [
      { id: 'skilsmisse', icon: '💔', label: 'Skilsmisse', desc: 'Separasjon eller skilsmisse' },
      { id: 'samlivsbrudd', icon: '🏠', label: 'Samlivsbrudd', desc: 'Samboerbrudd med formue' },
      { id: 'arv', icon: '📜', label: 'Arv & Testament', desc: 'Arvespmål eller testamente' },
      { id: 'barnefordeling', icon: '👶', label: 'Barnefordeling', desc: 'Foreldreansvar og samvær' },
      { id: 'annet_familie', icon: '⚡', label: 'Annet', desc: 'Annen familie- eller arverettslig sak' }
    ]
  },
  { 
    id: 'selskap', 
    icon: '💼', 
    label: 'Selskapsrett', 
    desc: 'Bedrift, aksjer, styre',
    subCategories: [
      { id: 'aksjonaer', icon: '📊', label: 'Aksjonærtvister', desc: 'Konflikt mellom eiere' },
      { id: 'styre', icon: '👔', label: 'Styreansvar', desc: 'Styremedlemmers ansvar' },
      { id: 'konkurs', icon: '⚖️', label: 'Konkurs', desc: 'Insolvens eller rekonstruksjon' },
      { id: 'oppstart', icon: '🚀', label: 'Oppstart & Struktur', desc: 'Etablering av selskap' },
      { id: 'annet_selskap', icon: '⚡', label: 'Annet', desc: 'Annen selskapsrettslig sak' }
    ]
  },
  { 
    id: 'gjeld', 
    icon: '💸', 
    label: 'Gjeld & Inkasso', 
    desc: 'Gjeldsproblemer, betalingsanmerkning',
    subCategories: [
      { id: 'inkasso', icon: '📬', label: 'Inkassosak', desc: 'Innkrevingssak eller varsel' },
      { id: 'betalingsanmerkning', icon: '⚠️', label: 'Betalingsanmerkning', desc: 'Fjerning av anmerkning' },
      { id: 'gjeldsordning', icon: '📋', label: 'Gjeldsordning', desc: 'Søknad om gjeldsordning' },
      { id: 'krav', icon: '💰', label: 'Pengekrav', desc: 'Noen skylder deg penger' },
      { id: 'annet_gjeld', icon: '⚡', label: 'Annet', desc: 'Annen gjelds- eller inkassosak' }
    ]
  },
  { 
    id: 'erstatning', 
    icon: '🚗', 
    label: 'Erstatning', 
    desc: 'Ulykke, forsikring, personskade',
    subCategories: [
      { id: 'trafikkulykke', icon: '🚙', label: 'Trafikkulykke', desc: 'Bilulykke eller personskade' },
      { id: 'yrkesskade', icon: '🏗️', label: 'Yrkesskade', desc: 'Skade på jobb' },
      { id: 'forsikring', icon: '🛡️', label: 'Forsikringstvister', desc: 'Forsikring nekter utbetaling' },
      { id: 'produktansvar', icon: '📦', label: 'Produktansvar', desc: 'Defekt produkt ga skade' },
      { id: 'annet_erstatning', icon: '⚡', label: 'Annet', desc: 'Annen erstatningssak' }
    ]
  },
  { 
    id: 'annet', 
    icon: '⚡', 
    label: 'Annet', 
    desc: 'Andre juridiske spørsmål',
    subCategories: []
  }
];

// Categories for companies
export const companyCaseCategories = [
  {
    id: 'arbeidsrett_bedrift',
    icon: '👔',
    label: 'Arbeidsrett',
    desc: 'Ansettelse, oppsigelse, arbeidsavtaler',
    subCategories: []
  },
  {
    id: 'kontrakt_bedrift',
    icon: '📄',
    label: 'Kontraktsrett',
    desc: 'Leverandøravtaler, kundekontrakter, B2B',
    subCategories: []
  },
  {
    id: 'selskapsrett',
    icon: '🏬',
    label: 'Selskapsrett',
    desc: 'Styre, aksjonærer, struktur, fusjoner',
    subCategories: []
  },
  {
    id: 'inkasso_bedrift',
    icon: '💰',
    label: 'Inkasso & Fordringer',
    desc: 'Innkreving, fakturakrav, betalingsmislighold',
    subCategories: []
  },
  {
    id: 'immaterialrett',
    icon: '©️',
    label: 'Immaterialrett',
    desc: 'Varemerke, patent, opphavsrett, design',
    subCategories: []
  },
  {
    id: 'eiendom_bedrift',
    icon: '🏭',
    label: 'Næringseiendom',
    desc: 'Kontorlokaler, lager, næringsleie',
    subCategories: []
  },
  {
    id: 'skatt',
    icon: '🧾',
    label: 'Skatt & Avgift',
    desc: 'MVA, skattesaker, revisor, toll',
    subCategories: []
  },
  {
    id: 'tvister',
    icon: '⚖️',
    label: 'Tvister & Søksmål',
    desc: 'Forretningstvister, voldgift, rettsaker',
    subCategories: []
  },
  {
    id: 'gdpr',
    icon: '🔒',
    label: 'GDPR & Personvern',
    desc: 'Databeskyttelse, personvern, compliance',
    subCategories: []
  },
  {
    id: 'konkurs',
    icon: '📉',
    label: 'Konkurs & Rekonstruksjon',
    desc: 'Insolvens, gjeldsforhandling, konkursbo',
    subCategories: []
  },
  {
    id: 'annet_bedrift',
    icon: '⚡',
    label: 'Annet',
    desc: 'Andre bedriftsjuridiske spørsmål',
    subCategories: []
  }
];

/**
 * Get categories based on client type
 */
export const getCategoriesByClientType = (clientType) => {
  return clientType === 'PERSON' ? privateCaseCategories : companyCaseCategories;
};

/**
 * Find a category by ID
 */
export const findCategory = (categoryId, clientType) => {
  const categories = getCategoriesByClientType(clientType);
  return categories.find(c => c.id === categoryId);
};

/**
 * Find a subcategory by ID within a category
 */
export const findSubCategory = (categoryId, subCategoryId, clientType) => {
  const category = findCategory(categoryId, clientType);
  if (!category || !category.subCategories) return null;
  return category.subCategories.find(s => s.id === subCategoryId);
};
